/** The navbar's shared looks (components/nav/SiteNav.tsx), for the controls pages put on it. */

/** The quiet round button every control on the bar is drawn as. */
export const NAV_BTN =
  'grid h-9 w-9 shrink-0 place-items-center rounded-full text-ink-600 transition hover:bg-ink-100 hover:text-ink-900 ' +
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-400 dark:text-ink-300 dark:hover:bg-white/[0.08] dark:hover:text-white';

/** A search box as the bar draws one: the page's search lives in `tools`. */
export const NAV_SEARCH =
  'h-9 w-full rounded-full border border-ink-200 bg-ink-50 pl-9 pr-3 text-[13.5px] text-ink-900 placeholder:text-ink-400 ' +
  'transition focus:border-accent-400 focus:bg-white focus:outline-none focus:ring-2 focus:ring-accent-400/20 ' +
  'dark:border-white/10 dark:bg-white/[0.06] dark:text-white dark:placeholder:text-white/40 dark:focus:border-accent-400/60 dark:focus:bg-white/[0.09]';
